<template>
    <div>
        <div v-if="!response" class="no-answer">
            <span>
                Not Answered
            </span>
        </div>
        <div v-for="(option, index) in question.option"
            :key="'pre' + index"
            :class="['choice', 'select-choice', { selected: response != null && response.includes(option) }]">
            <template v-if="isNonBlankAnswer(option)">
                {{ option }}
            </template>
            <template v-else>
                &nbsp;
            </template>
        </div>
        <div v-for="(option, index) in response"
            :key="'other' + index"
            v-if="!question.option.includes(option)"
            class="choice select-choice custom-choice selected">
            {{ option }}
        </div>
    </div>
</template>

<script>

export default {   
    name: 'select-partial',

    props: {
        // Content object for this question
		question: {
			type: Object,
			required: true
		},
		response: {
			type: Array,
		}
    },
    
    methods: {
        isNonBlankAnswer(answer) {
			return answer.trim().length > 0
		},
    }
}
</script>

<style lang="scss" scoped>
@import "../style.scss";
</style>
